import { ValgAutofocusDirective } from "./valg-autofocus.directive";
import { NgModule } from '@angular/core';
import { ValgScrollToDirective } from "./valg-scroll-to.directive";
import { ValgAuthorizationDirective } from "./valg-authorization.directive";
import { DomainValidationResultAnnouncerDirective } from "./domain-validation-result-announcer.directive";
import { ValgYesNoOptionInputDirective } from "./valg-yes-no-option-input.directive";
import { ValgInputRequiredOnConditionDirective } from "./valg-input-required-on-condition.directive";
import { NumberFormatDirective } from "./number-input.directive";
import { ValgConfirmationInputDirective } from "./valg-confirmation-input.directive";
import { CprInputFormatDirective } from "./cpr-input-format.directive";

@NgModule({
    declarations: [
        ValgAutofocusDirective,
        ValgScrollToDirective,
        ValgAuthorizationDirective,
        DomainValidationResultAnnouncerDirective,
        ValgYesNoOptionInputDirective,
        ValgInputRequiredOnConditionDirective,
        NumberFormatDirective,
        CprInputFormatDirective,
        ValgConfirmationInputDirective
    ],
    exports: [
        ValgAutofocusDirective,
        ValgScrollToDirective,
        ValgAuthorizationDirective,
        DomainValidationResultAnnouncerDirective,
        ValgYesNoOptionInputDirective,
        ValgInputRequiredOnConditionDirective,
        NumberFormatDirective,
        CprInputFormatDirective,
        ValgConfirmationInputDirective
    ],
})
export class ValgSharedDirectivesModule {
}
